import { IOfferScopeListTableLang } from '../../../types/lang'

export const offerScopeListTableLang: IOfferScopeListTableLang = {
	offer_scope_list_table: {
		column_id: 'ID',
		column_name: 'Name',
		column_offer_id: 'Offer ID',
		column_notes: 'Notes',
		column_affiliate_network: 'Affiliate Network',
		column_country: 'Country',
		column_sales_cap: 'Sales/Cap',
		column_diff: 'Diff',
		column_cap_type: 'Type',
		column_status: 'Status',
	}
}